import { useFormServerErrorHandler } from 'hooks';
import { unitErrorCodeTypes } from 'activate-errors';
import { getErrorCodes } from 'lane-shared/helpers';
import { ChannelExperienceTypeEnum } from 'constants-channel';
import { ServerErrorCodeToFieldMapping } from '../../types';
import { useTranslation } from 'react-i18next';

export const useUnitErrorHandling = (
  channelExperienceType: ChannelExperienceTypeEnum | null | undefined
) => {
  const { t } = useTranslation();
  const unitType =
    channelExperienceType === ChannelExperienceTypeEnum.multifamily
      ? 'unit'
      : 'suite';

  const localUnitErrorCodeTypes = { ...unitErrorCodeTypes };

  localUnitErrorCodeTypes.unitNameAlreadyExistsError.message = t(
    'web.admin.channel.suites.create.form.suite.validation.nameExists',
    { unitType }
  );

  const {
    serverFormFieldErrors,
    resetServerFormFieldErrors,
    handleServerError: handleServerFormError,
  } = useFormServerErrorHandler({
    errorCodeTypes: localUnitErrorCodeTypes,
    errorCodeToFormFieldMap: ServerErrorCodeToFieldMapping,
    show: (message: string) => window.Toast.show(message),
    defaultErrorMessage: t('shared.units.errors.generic'),
  });

  const handleServerError = (error: unknown) => {
    handleServerFormError(error);

    const codes = getErrorCodes(error);
    const isExternalReferenceError =
      codes.includes(
        unitErrorCodeTypes.unitExternalReferenceInvalidError.code
      ) ||
      codes.includes(
        unitErrorCodeTypes.saveUnitExternalReferencesFailedError.code
      );

    return isExternalReferenceError;
  };

  return {
    serverFormFieldErrors,
    resetServerFormFieldErrors,
    handleServerError,
  };
};
